import { api } from "@/lib/api";

const SESSION_KEY = "hh_estimator_session";
const INTERACT_FIRED_KEY = "hh_estimator_interact_fired";

function ensureSession() {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = crypto.randomUUID?.() || `s_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

// Fire-and-forget POST. Analytics failures never affect UX.
function send(payload) {
  api.post("/estimator/events", payload).catch(() => {});
}

export function trackEstimatorInteract(net, advance) {
  if (sessionStorage.getItem(INTERACT_FIRED_KEY) === "1") return;
  sessionStorage.setItem(INTERACT_FIRED_KEY, "1");
  send({
    event: "interact",
    session_id: ensureSession(),
    net_commission: net,
    advance,
  });
}

export function trackEstimatorApplyClick(net, advance) {
  send({
    event: "apply_click",
    session_id: ensureSession(),
    net_commission: net,
    advance,
  });
}
